import { nanoid } from "nanoid"

import { componentConfigApi } from "../../api/componentConfigApi.js"

import { componentConfigSignal, componentConfigLoadedSignal, componentConfigErrorSignal, componentPermanentIdSignal, ccApiInterfaceConfigSignal, ccCoreGlobalSignal, ccDeviceConfigSignal, ccExpressManagerSignal, ccMailServerSignal, ccUtgGlobalSignal, deviceConfigRecordSignal, deviceConfigRecordLoadedSignal, deviceConfigRecordErrorSignal, deviceConfigRecordsListSignal, deviceConfigRecordsListLoadedSignal, deviceConfigRecordsListErrorSignal } from '../signals/componentConfigSignals.js'

export const fetchComponentConfig = async (businessEntityId, machinePermanentId, componentPermanentId, config, accessToken, signal = null) => {
    try {
        componentConfigLoadedSignal.value = false
        componentConfigErrorSignal.value = null
        return await componentConfigApi.fetchComponentConfig(businessEntityId, machinePermanentId, componentPermanentId, config, accessToken, signal).then(
            (componentConfig) => {
                componentConfigSignal.value = componentConfig
                componentPermanentIdSignal.value = componentPermanentId; // allows us to short-circuit future calls when the data is already loaded

                // make sure we have apiInterfaceConfig and deviceConfig objects and child arrays
                componentConfigSignal.value = componentConfigSignal.value || {}
                componentConfigSignal.value.config = componentConfigSignal.value.config || {}
                componentConfigSignal.value.config.apiInterfaceConfig = componentConfigSignal.value.config.apiInterfaceConfig || {}
                componentConfigSignal.value.config.apiInterfaceConfig.apiInterface = componentConfigSignal.value.config.apiInterfaceConfig.apiInterface || []

                componentConfigSignal.value.config.deviceConfig = componentConfigSignal.value.config.deviceConfig || {}
                componentConfigSignal.value.config.deviceConfig.device = componentConfigSignal.value.config.deviceConfig.device || []

                // api interfaces need an id assigned
                let apiInterfaces = componentConfigSignal.value.config.apiInterfaceConfig.apiInterface
                apiInterfaces.map(
                    (apiInterface) => {
                        apiInterface.ccid = apiInterface.ccid ? apiInterface.ccid : nanoid()
                    }
                )

                // make sure that this value is not -1 or UTG will break when config is pushed
                const lowDiskSpaceThresholdMB = componentConfigSignal.value?.componentConfig?.config?.utgGlobal?.lowDiskSpaceThresholdMB
                if (lowDiskSpaceThresholdMB && lowDiskSpaceThresholdMB == -1) {
                    componentConfigSignal.value.config.utgGlobal.lowDiskSpaceThresholdMB = 2
                }

                ccApiInterfaceConfigSignal.value = componentConfigSignal.value.config.apiInterfaceConfig
                ccCoreGlobalSignal.value = componentConfigSignal.value.config.coreGlobal
                ccDeviceConfigSignal.value = componentConfigSignal.value.config.deviceConfig
                ccExpressManagerSignal.value = componentConfigSignal.value.config.expressManager
                ccMailServerSignal.value = componentConfigSignal.value.config.mailServer
                ccUtgGlobalSignal.value = componentConfigSignal.value.config.utgGlobal

                componentConfigLoadedSignal.value = true
                //console.log("Parsed the following component config:")
                //console.log(componentConfigSignal.value)
                return componentConfigSignal.value
            }
        ).catch(
            (err) => {
                componentConfigErrorSignal.value = err
                console.log(err)
            }
        )
    } catch (error) {
        componentConfigErrorSignal.value = error
        console.error(error)
        return null
    }
}

export const updateComponentConfig = async (businessEntityId, machinePermanentId, componentPermanentId, componentConfig, config, accessToken, reload=false) => {
    componentConfigLoadedSignal.value = false
    if (!businessEntityId) {
        throw Error("Business entity ID is undefined")
    }
    if (!machinePermanentId) {
        throw Error("Machine permanent ID is undefined")
    }
    if (!componentPermanentId) {
        throw Error("Component permanent ID is undefined")
    }
    if (!componentConfig) {
        throw Error("Compoent config is undefined")
    }
    return await componentConfigApi.updateComponentConfig(businessEntityId, machinePermanentId, componentPermanentId, componentConfig, config, accessToken).then(
        (componentConfig) => {
            if (reload) {
                componentConfigSignal.value = componentConfig
            }
            componentConfigLoadedSignal.value = true
            return componentConfig
        }
    ).catch(
        (error) => {
            componentConfigErrorSignal.value = error
            throw error
        }
    )
}

export const fetchDeviceConfigRecord = async (businessEntityId, componentId, deviceId, config, accessToken) => {
    deviceConfigRecordLoadedSignal.value = false
    deviceConfigRecordSignal.value = null
    return await componentConfigApi.fetchDeviceConfigRecord(businessEntityId, componentId, deviceId, config, accessToken).then(
        (record) => {
            deviceConfigRecordSignal.value = record
            deviceConfigRecordLoadedSignal.value = true
        }
    ).catch(
        (err) => {
            deviceConfigRecordErrorSignal.value = err
        }
    )
}

export const fetchDeviceConfigRecordsList = async (businessEntityId, componentId, config, accessToken) => {
    deviceConfigRecordsListLoadedSignal.value = false
    deviceConfigRecordsListSignal.value = null
    return await componentConfigApi.fetchDeviceConfigRecordsList(businessEntityId, componentId, config, accessToken).then(
        (record) => {
            deviceConfigRecordsListSignal.value = record
            deviceConfigRecordsListLoadedSignal.value = true
        }
    ).catch(
        (err) => {
            deviceConfigRecordsListErrorSignal.value = err
        }
    )
}